import TiptapTable from "@tiptap/extension-table";
import { TableCell } from "@tiptap/extension-table-cell";
import { TableHeader } from "@tiptap/extension-table-header";
import { TableRow } from "@tiptap/extension-table-row";

import { TableCellBackground } from "./cell-background";
import TableActionButton from "../../extensions/Table/components/TableActionButton";

export const Table = TiptapTable.extend({
	addOptions() {
		return {
			...this.parent?.(),
			resizable: true,
			lastColumnResizable: true,
			allowTableNodeSelection: false,
			button: ({ editor, t }) => ({
				component: TableActionButton,
				componentProps: {
					icon: "Table",
					tooltip: t("editor.table.tooltip"),
					editor
				}
			})
		};
	},

	addExtensions() {
		return [
			TableRow.configure(this.options.tableRow),
			TableHeader.configure(this.options.tableHeader),
			TableCell.configure(this.options.tableCell),
			TableCellBackground.configure(this.options.tableCellBackground)
		];
	}
});

export default Table;
